import { newToolFilterOAuthMcp } from "../oauth.ts";

export const linearMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://linear.app/static/favicon.svg",
  url: "https://mcp.linear.app/mcp",
  label: "Linear",
});
